export const UserCapacityModel = Symbol.for('UserCapacityModel');
